import { DisplayElement, filterDisplayElementHideCondition } from '@urbanx/agx-ui-components';
import { CampaignDetailModel, FormPage } from '@urbanx/agx.campaigns.client';
import { AgxPanel, AgxSpacer } from '@urbanx/agx.ui-components2';
import slugify from 'slugify';
import { FormValue, FormValueType } from 'types/formConfig';
import elementRenderer from 'utils/elementRenderer';
import { useSelectedAgency } from 'hooks';
import { SellerDisclosureModalValues } from 'components/sellers-disclosure-upload/SellerDisclosureModal';

interface PanelElementRendererProps {
  panel: FormPage;
  formValues: FormValue;
  getAuthToken: () => Promise<string>;
  onChange: (change: { id: string; value: FormValueType[keyof FormValueType] }) => void;
  campaign: CampaignDetailModel;
  validate: boolean;
  onSellerDisclosureComplete: (values: SellerDisclosureModalValues) => Promise<void>;
}

const PanelElementRenderer = ({
  panel,
  formValues,
  getAuthToken,
  onChange,
  campaign,
  validate,
  onSellerDisclosureComplete,
}: PanelElementRendererProps) => {
  const { agency } = useSelectedAgency();
  const slugifiedPanelName = slugify(panel.name ?? '');

  const elements = filterDisplayElementHideCondition(
    (panel?.elements ?? []) as unknown as DisplayElement[],
    formValues
  );

  const renderedElements =
    panel.elements &&
    elementRenderer({
      elements: elements,
      onChange,
      campaign,
      agencyId: agency?.id,
      getAuthToken,
      formValues,
      validate,
      onSellerDisclosureComplete,
    });

  if (panel.hideFormPageName) {
    return (
      <AgxSpacer
        direction="vertical"
        gap="lg"
        key={slugifiedPanelName}
        id={slugifiedPanelName}
        className="blankContractSection"
      >
        {renderedElements}
      </AgxSpacer>
    );
  }

  return (
    <AgxPanel
      key={slugifiedPanelName}
      id={slugifiedPanelName}
      header={panel.name}
      className="blankContractSection"
    >
      {renderedElements}
    </AgxPanel>
  );
};

export default PanelElementRenderer;
